import FixedCostCreation from "./fixed_cost_creation.coffee"
import NewEntry from "./new_entry.coffee"

$(document).on 'turbolinks:load', ->
  new FixedCostCreation().handler_events()
  new NewEntry().add_listener()